import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import esTranslation from './es.json';
import plTranslation from './pl.json';

const resources = {
  es: {
    translation: esTranslation,
  },
  pl: {
    translation: plTranslation,
  },
};

const DEFAULT_LANGUAGE = 'pl';
const supportedLanguages = ['es', 'pl'];

const syncDocumentLanguage = (language) => {
  if (typeof document === 'undefined') {
    return;
  }

  document.documentElement.lang = language;
};

i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: supportedLanguages,
  nonExplicitSupportedLngs: true,
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

if (typeof window !== 'undefined') {
  window.localStorage.setItem('i18nextLng', DEFAULT_LANGUAGE);
}

syncDocumentLanguage(i18n.resolvedLanguage || i18n.language || DEFAULT_LANGUAGE);

i18n.on('languageChanged', (language) => {
  const normalizedLanguage = language.toLowerCase().split('-')[0];
  const documentLanguage = supportedLanguages.includes(normalizedLanguage)
    ? normalizedLanguage
    : DEFAULT_LANGUAGE;

  syncDocumentLanguage(documentLanguage);

  if (typeof window !== 'undefined') {
    window.localStorage.setItem('i18nextLng', documentLanguage);
  }
});

export default i18n;
